import { ListStatus, ListType } from "@/enum/list.enum";
import { Toggle } from "@/components/Toggle/Toggle";
import { ToggleColor } from "@/components/Toggle/types";
import { Tooltip } from "@/components/Tooltip/Tooltip";

import { ListTypeElement } from "@/pages/Private/pages/List/components/ListTypeElement";
import { List } from "@/pages/Private/pages/List/schema/list";

export const renderListMeta = (list: List): JSX.Element => (
	<div className="flex items-center gap-3">
		<ListTypeElement list={list} />
		<Tooltip content={list.status === ListStatus.ACTIVE ? "Active" : "Inactive"}>
			<Toggle
				disabled
				color={list.type === ListType.ONCE ? ToggleColor.ONCE : ToggleColor.ON_GOING}
				isChecked={list.status === ListStatus.ACTIVE}
			/>
		</Tooltip>
	</div>
);
